import React, {
  useRef,
  useState,
  memo,
  useImperativeHandle,
  forwardRef,
} from "react";
import {
  StyleSheet,
  View,
  Animated,
  TouchableOpacity,
  Modal,
} from "react-native";
import Text from "@components/AppText";
import CloseIcon from "@assets/svg/CloseIcon";
import t from "@constants/localization";

const TnC = memo(
  forwardRef(({ terms = [] }, ref) => {
    const [mainWrapperHeight, setMainWrapperHeight] = useState(300);
    const transformVertical = useRef(new Animated.Value(300));
    const [visible, setVisible] = useState(false);

    useImperativeHandle(ref, () => ({
      openModal: () => {
        setVisible(true);
        Animated.timing(transformVertical.current, {
          toValue: 0,
          duration: 300,
          useNativeDriver: true,
        }).start();
      },
    }));
    const closeModal = () => {
      Animated.timing(transformVertical.current, {
        toValue: mainWrapperHeight,
        duration: 300,
        useNativeDriver: true,
      }).start();
      setVisible(false);
    };

    return (
      <Modal
        statusBarTranslucent
        navigationBarTranslucent
        transparent
        visible={visible}
      >
        <View
          style={styles.container}
          onLayout={({
            nativeEvent: {
              layout: { x, y, width, height },
            },
          }) => {
            setMainWrapperHeight(height);
          }}
        >
          <Animated.View
            style={[
              styles.wrapper,
              { transform: [{ translateY: transformVertical.current }] },
            ]}
          >
            <View style={[styles.beLikeRow, styles.headContainer]}>
              <Text bold fontType="head3">
                {t("screens/Wallet/TnC/TnC")}
              </Text>
              <TouchableOpacity
                onPress={() => {
                  closeModal();
                }}
              >
                <CloseIcon fillOpacity={0.7} width={24} height={24} />
              </TouchableOpacity>
            </View>
            <View style={styles.termsContainer}>
              <View style={styles.terms}>
                {terms.map((term) => (
                  <View style={styles.term} key={term}>
                    <Text
                      style={{
                        color: "rgba(0, 0, 0, .56)",
                      }}
                    >
                      • {term}
                    </Text>
                  </View>
                ))}
              </View>
            </View>
          </Animated.View>
        </View>
      </Modal>
    );
  }),
);

const styles = StyleSheet.create({
  beLikeRow: {
    flexDirection: "row",
    alignItems: "center",
    width: "100%",
  },
  container: {
    flex: 1,
    ...StyleSheet.absoluteFill,
    backgroundColor: "rgba(0, 0, 0, 0.56)",
  },
  wrapper: {
    backgroundColor: "#fff",
    position: "absolute",
    bottom: 0,
    borderTopLeftRadius: 15,
    borderTopRightRadius: 15,
    width: "100%",
    paddingBottom: 40,
  },
  headContainer: {
    marginVertical: 10,
    paddingHorizontal: 20,
    justifyContent: "space-between",
    marginTop: 20,
  },
  termsContainer: {
    marginTop: 5,
  },
  terms: {
    paddingHorizontal: 10,
  },
  term: {
    marginVertical: 5,
    paddingLeft: 5,
  },
});

export default TnC;
